export const ROLES = {
    ADMIN: 1,
    SALES: 2,
    ACCOUNTING: 3,
};
